module.exports = __webpack_public_path__ + "img/4.5f4ae6b4.jpg";